import React, { useState, useEffect } from 'react';
import { getToolsFromFirestore } from '../../firebase/toolService';
import { getStatesFromFirestore } from '../../firebase/stateService';
import { useAuth } from '../../firebase/AuthContext';
import styles from './Post.module.css';
import ImageUploader from '../../Components/ImageUploader/ImageUploader';
import { addPostToFirestore } from '../../firebase/postService';
import { uploadPostImage } from '../../firebase/postImageService';
import { getAuth } from 'firebase/auth';
import { Loading } from '../../Components';
import SelectInput from '../../Components/SelectInput/SelectInput';

const Post = () => {
  const { user } = useAuth();
  const [tools, setTools] = useState([]);
  const [selectedToolIds, setSelectedToolIds] = useState([]);

  useEffect(() => {
    const fetchTools = async () => {
      if (!user) return;
      const data = await getToolsFromFirestore(user.uid);
      setTools(data);
    };
    fetchTools();
  }, [user]);

  const [workName, setWorkName] = useState('');
  const [workDescription, setWorkDescription] = useState('');
  const [workImages, setWorkImages] = useState([]);
  const [workState, setWorkState] = useState('');
  const [stateList, setStateList] = useState([]);
  // 投稿用状態の選択肢を取得
  useEffect(() => {
    const fetchStates = async () => {
      if (!user) return;
      const data = await getStatesFromFirestore(user.uid, 'post');
      setStateList(data);
    };
    fetchStates();
  }, [user]);

  const [loading, setLoading] = useState(false);
  const handleToolSelect = (e) => {
    const value = e.target.value;
    setSelectedToolIds(prev =>
      prev.includes(value)
        ? prev.filter(id => id !== value)
        : [...prev, value]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // 画像アップロード
      const user = getAuth().currentUser;
      const userId = user ? user.uid : 'anonymous';
      let imageUrls = [];
      if (workImages.length > 0) {
        imageUrls = await Promise.all(
          workImages.map((file, idx) => uploadPostImage(file, userId, workName, idx))
        );
      }
      // Firestoreへ保存
      await addPostToFirestore({
        workName,
        workDescription,
        workState,
        images: imageUrls,
        toolIds: selectedToolIds
      }, user ? { uid: user.uid, displayName: user.displayName } : { uid: userId, displayName: '' });
  // alert('作品が投稿されました！');
  setWorkName('');
  setWorkDescription('');
  setWorkImages([]);
  setSelectedToolIds([]);
  setWorkState('');
    } catch (err) {
      // alert('投稿に失敗しました: ' + (err?.message || err));
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <div className={styles.container}>
      <h2>作品を投稿</h2>
      <form onSubmit={handleSubmit} className={styles.form}>
        <label>
          作品名
          <input
            type="text"
            value={workName}
            onChange={(e) => setWorkName(e.target.value)}
            required
            className={styles.input}
          />
        </label>
        <ImageUploader
          images={workImages}
          setImages={setWorkImages}
          max={3}
          label="作品画像"
          className={styles.imageUploadBlock}
        />
        <SelectInput
          label="状態"
          value={workState}
          onChange={e => setWorkState(e.target.value)}
          options={[{ id: '', name: '状態を選択' }, ...stateList]}
          placeholder="状態を選択"
          className={styles.input}
          required
        />
        <label>
          使用した道具（複数選択可）
          <div className={styles.toolCheckboxList} style={{marginBottom: 8}}>
            {tools.length === 0 ? (
              <div style={{color:'#888'}}>登録された道具がありません</div>
            ) : (
              tools.map(tool => (
                <label key={tool.id} style={{display:'block',marginBottom:4}}>
                  <input
                    type="checkbox"
                    value={tool.id}
                    checked={selectedToolIds.includes(tool.id)}
                    onChange={handleToolSelect}
                  />
                  {tool.name}
                </label>
              ))
            )}
          </div>
        </label>
        <label>
          作品説明
          <textarea
            value={workDescription}
            onChange={(e) => setWorkDescription(e.target.value)}
            className={styles.textarea}
          />
        </label>
        <button type="submit" className={styles.button} disabled={loading}>{loading ? '投稿中...' : '投稿'}</button>
      </form>
    </div>
  );
};

export default Post;
